<template>
  <main id="content" class="grid-x contact-page">
    <article class="main cell
                    small-offset-0
                    medium-offset-1 medium-9
                    middle-offset-3 middle-7">
      <h1>Workalicious</h1>
      <p class="author">work by Dave Kaplan</p>
      <p>
        I like in-person kick-offs and getting out of my office for coffee.
        If things go well this year I'm going to order coffee mugs with the Workalicious logo on it.
      </p>
      <p>
        I'm currently looking for new work.
      </p>
      <p>
      </p>


      <address class="work-address">
        <a href="mailto:work@workalicious.com">work@workalicious.com</a> <br>
        <a href="tel:+17735975001">773-597-5001</a>
      </address>

    </article>
  </main>
</template>

<script>
  export default {}
</script>

<style lang="scss">
  @import '~foundation-sites/scss/foundation.scss';
  @import '../css/settings';
  @import '../css/colors';

  .contact-page {
    padding-bottom: 3rem;
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 2%;
    line-height: 1;

    h1, h2, h3, h4 {
      color: $deepBlue;
      font-family: "Verlag A", "Verlag B", sans-serif;
      font-style: normal;
      font-weight: 700;
    }

    h2, h3 {
      font-size: .875rem;
      outline: 1px solid $deepHaze;
      margin-bottom: 0;
    }

    p, address {
      font-family: "Chronicle SSm A", "Chronicle SSm B", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: .9375rem;
      @include breakpoint(medium) {
        font-size: 1rem;
      }
      @include breakpoint(large) {
        padding-right: 2rem;
      }
    }
    .author {
      font-style: italic;
      font-size: .9rem;
    }

    .work-address a,
    .work-address {
      font-size: 1.2rem;
      line-height: 1.4;
      font-family: "Verlag A", "Verlag B", sans-serif;
      font-style: normal;
      font-weight: 700;
      color: $deepHaze;

      /*
      &:hover {
        color: $deepBlue;
        text-decoration: underline;
      }
      &::after {
        content: "\f010";
        padding-left: .4rem;
        font-family: 'SocialBrands-Regular', sans-serif;
        font-size: 1rem;
        font-weight: normal;
        speak: none;
      }
      */

    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Contact.vue